import React from 'react';
import styled from 'styled-components';

export default function FilterButton({ text, textalign = 'left' }) {
	return (
		<Container className='filter-button' textalign={textalign}>
			<Text>{text}</Text>
		</Container>
	);
}

const Container = styled.div`
	border: 1px solid var(--button-border-color);
	border-radius: 5px;
	padding: 7px 17px;
	font-family: 'NotoSansRg';
	font-weight: 500;
	font-size: 12px;
	text-align: ${props => props.textalign};
`;

const Text = styled.span`
	color: var(--third-text-color);
`;
